// LWI-1549 — the classic MSR routes now land on the wizard. Old deep links
// carried the classic tab in `?tab=`; map each one onto its wizard section so
// bookmarks, emails and the Customs Invoice back-link keep working.

export const WIZARD_BASE = "/outbound/msr/wizard";

/** Classic Details `?tab=` value → wizard section key (Details → default landing). */
export const CLASSIC_TAB_SECTIONS = {
  details: null,
  pickandpack: "pp-customer-info",
  bol: "bol",
  exceptions: "exceptions",
  audit: "audit",
  systemlog: "system-log",
  downloads: "downloads",
};

export const wizardUrl = (msrNumber, section) => {
  const base = `${WIZARD_BASE}/${
    msrNumber ? encodeURIComponent(msrNumber) : "new"
  }`;
  return section ? `${base}/${section}` : base;
};

/** Where `/outbound/msr/details/{id}?tab=X` should go. */
export const detailsRedirectTarget = (msrNumber, tab) => {
  const key = String(tab || "").toLowerCase();
  const section = Object.prototype.hasOwnProperty.call(
    CLASSIC_TAB_SECTIONS,
    key
  )
    ? CLASSIC_TAB_SECTIONS[key]
    : null;
  return wizardUrl(msrNumber, section);
};

// LWI-1596 — a new MSR opens on the combined Shipment and Parts tab.
export const NEW_MSR_URL = wizardUrl(null, "shipment");

// LWI-1577 — the classic Details page is back as the "Super User View", one
// click from the navbar. These map an MSR page's URL onto the other view,
// keeping the tab/section the user was on.

export const REVIEWER_BASE = "/outbound/msr/classic/details";
export const REVIEWER_NEW_URL = "/outbound/msr/classic/add";

/** Wizard section key → classic Details `?tab=` value (null → the Details tab). */
export const sectionToClassicTab = (section) => {
  const key = String(section || "");
  if (key.startsWith("pp-")) return "PickAndPack";
  const match = Object.entries(CLASSIC_TAB_SECTIONS).find(([, s]) => s === key);
  if (!match || !match[1]) return null;
  // CLASSIC_TAB_SECTIONS keys are lower-cased; the classic page's Tab values are not.
  return { bol: "BOL", systemlog: "systemLog" }[match[0]] || match[0];
};

export const reviewerUrl = (msrNumber, section) => {
  const tab = sectionToClassicTab(section);
  const base = `${REVIEWER_BASE}/${encodeURIComponent(msrNumber)}`;
  return tab ? `${base}?tab=${tab}` : base;
};

/**
 * Which view the given location is, and the URL of the other one for the
 * same MSR. A new MSR switches between the two create pages. Null anywhere
 * else (dashboard, other modules).
 * @returns {{ current: "wizard" | "reviewer", target: string } | null}
 */
export const msrViewSwitch = (pathname, search = "") => {
  const wizard = String(pathname || "").match(
    /^\/outbound\/msr\/wizard\/([^/]+)(?:\/([^/]+))?\/?$/
  );
  if (wizard) {
    const msrNumber = decodeURIComponent(wizard[1]);
    if (msrNumber === "new") {
      return { current: "wizard", target: REVIEWER_NEW_URL, isNew: true };
    }
    return { current: "wizard", target: reviewerUrl(msrNumber, wizard[2]) };
  }
  if (/^\/outbound\/msr\/classic\/add\/?$/.test(String(pathname || ""))) {
    return { current: "reviewer", target: NEW_MSR_URL, isNew: true };
  }
  const reviewer = String(pathname || "").match(
    /^\/outbound\/msr\/classic\/details\/([^/]+)\/?$/
  );
  if (reviewer) {
    const tab = new URLSearchParams(search).get("tab");
    return {
      current: "reviewer",
      target: detailsRedirectTarget(decodeURIComponent(reviewer[1]), tab),
    };
  }
  return null;
};
